import { EntityVm } from 'api/core/entity.vm';
import { IsString, IsDate, IsOptional, IsEnum } from 'class-validator';

export enum BatchStatus {
  UNINITIALIZED = 'UNINITIALIZED',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export class BatchVm extends EntityVm {
  @IsString()
  productId: string;

  @IsString()
  barcode: string;

  @IsDate()
  @IsOptional()
  expiration: Date;

  @IsEnum(BatchStatus)
  status: BatchStatus;
}
